// Maps a gem's `source_type` to a recognisable icon + human label.
// Browser-safe; used by the detail card and (later) the grid badge.

import {
  GitBranch,
  Globe,
  LibraryBig,
  MessageSquare,
  Package,
  PenTool,
  Sparkles,
  type LucideIcon,
} from "@/components/icons";

export type GemSource = {
  icon: LucideIcon;
  label: string;
  short: string;
};

const MAP: Record<string, GemSource> = {
  github: { icon: GitBranch, label: "GitHub repository", short: "GitHub" },
  site: { icon: Globe, label: "Website", short: "Site" },
  directory: { icon: LibraryBig, label: "Directory", short: "Directory" },
  reddit: { icon: MessageSquare, label: "Reddit thread", short: "Reddit" },
  "x-thread": { icon: MessageSquare, label: "Thread on X", short: "X thread" },
  skill: { icon: Sparkles, label: "Agent skill", short: "Skill" },
  figma: { icon: PenTool, label: "Figma file", short: "Figma" },
  npm: { icon: Package, label: "npm package", short: "npm" },
};

export function gemSource(sourceType?: string | null): GemSource {
  const key = (sourceType ?? "").toLowerCase();
  return MAP[key] ?? { icon: Globe, label: "Website", short: "Site" };
}

/** Favicon for a gem's domain; falls back to the source icon if it fails. */
export function faviconFor(domain: string): string {
  return `https://www.google.com/s2/favicons?domain=${encodeURIComponent(domain)}&sz=64`;
}
